
   export const schoolTittles = {
      prePrimary  :'PRE-PRIMARY SECTION',
        primary:'PRIMARY SECTION',
       jss: 'JUNIOR SECONDARY SCHOOL SECTION',
        secondary:'SECONDARY SCHOOL SECTION',
        senior: "SENIOR SCHOOL SECTION",
        teachersCollage:'COLLAGE & UNIVERSITY'
   }
        
   
   export  const prePrimaryItems = [
        { label: "PRE-PRIMARY SCHEMES OF WORK", value: "/pre/primary/schemes", path: "pre/primary"},
        { label: "PRE-PRIMARY CURRICULUM DESIGNS", value: "/pre/primary/curriculum/designs", path: "pre/primary"},
        { label: "PLAYGROUP EXAMS", value: "/play/group/exams", path: "pre/primary" },
        { label: "PP1 EXAMS", value: "/pp1/exams" , path: "pre/primary"},
        { label: "PP2 EXAMS", value: "/pp2/exams" , path: "pre/primary"},
        { label: "PRE-PRIMARY HOLIDAY REVISIONS", value: "/pre/primary/holiday/assignments" , path: "pre/primary"},       
        { label: "PLAYGROUP COLOURING PAGES", value: "/play/group/colouring" , path: "pre/primary"},       
        { label: "PRE PRIMARY LESSON PLANS", value: "/pre/primary/lesson/plans" , path: "pre/primary"},       
        { label: "PRE PRIMARY TEACHING AIDS", value: "/pre/primary/teaching/aids" , path: "pre/primary"},       
        
    ]

   export  const primaryItems = [
        { label: "PRIMARY SCHEMES OF WORK", value: "/primary/schemes",path: "primary" },
        { label: "PRIMARY LESSON PLANS", value: "/primary/lesson/plans",path: "primary" },
        { label: "PRIMARY CURRICULUM DESIGNS", value: "/primary/curriculum/designs" ,path: "primary"},
        { label: "PRIMARY ASSESSMENT TOOLS ", value: "/primary/assessment/tools" ,path: "primary"},
        
        { label: "GRADE 1 EXAMINATIONS ", value: "/grade1/examinations" ,path: "primary"},
        { label: "GRADE 2 EXAMINATIONS ", value: "/grade2/examinations" ,path: "primary"},
        { label: "GRADE 3 EXAMINATIONS ", value: "/grade3/examinations" ,path: "primary"},
        { label: "GRADE 4 EXAMINATIONS  ", value: "/grade4/examinations" ,path: "primary"},
        { label: "GRADE 5 EXAMINATIONS  ", value: "/grade5/examinations" ,path: "primary"},
        { label: "GRADE 6 EXAMINATIONS  ", value: "/grade6/examinations" ,path: "primary"},
        { label: "PRIMARY SCHOOL NOTES  ", value: "/primary/revision/notes" ,path: "primary"},
        { label: "PRIMARY HOLIDAY ASSIGNMENTS   ", value: "/primary/holiday/assignments" ,path: "primary"},
        
    ]

export const jssItems = [
        { label: "JUNIOR SCHOOL SCHEMES OF WORK ", value: "/jss/schemes",path: "jss" },
        { label: "JUNIOR SCHOOL ASSESSMENT TOOLS  ", value: "/jss/assessment/tools" ,path: "jss"},
        { label: "GRADE 7 EXAMINATIONS  ", value: "/grade7/examinations" ,path: "jss"},
        { label: "GRADE 8 EXAMINATIONS  ", value: "/grade8/examinations" ,path: "jss"},
        { label: "GRADE 9 EXAMINATIONS  ", value: "/grade9/examinations" ,path: "jss"},
        { label: "JUNIOR SCHOOL CURRICULUM DESIGNS  ", value: "/jss/curriculum/designs" ,path: "jss"},
        { label: "JUNIOR SCHOOL NOTES  ", value: "/jss/notes" ,path: "jss"},        
        { label: "JUNIOR SCHOOL LESSON PLANS  ", value: "/jss/lesson/plans" ,path: "jss"},        
        { label: "JUNIOR SCHOOL HOLIDAY ASSIGNMENTS   ", value: "/jss/holiday/assignments" ,path: "jss"}
       
]
export const seniorSchoolItems = [
        { label: "SENIOR SCHOOL SCHEMES OF WORK ", value: "/senior/school/schemes",path: "senior" },       
        { label: "SENIOR SCHOOL LESSON PLANS ", value: "/senior/school/lesson/plans",path: "senior" },       
        { label: "GRADE 10 EMAMINATIONS  ", value: "/grade10/examinations" ,path: "senior"},        
        { label: "GRADE 10 EVALUATION TEST  ", value: "/grade10/evaluations" ,path: "senior"},        
        { label: "SENIOR SCHOOL CURRICULUM DESIGNS  ", value: "/senior/school/curriculum/designs" ,path: "senior"},
        { label: "SENIOR SCHOOL NOTES  ", value: "/senior/school/notes" ,path: "senior"},        
    
       
]

export const secondaryItems = [
       { label: "SECONDARY FULL SET EXAMINATIONS ", value: "/secondary/fullset/examinations" ,path: "secondary"},
       { label: "SECONDARY SCHEMES OF WORK  ",  value: "/secondary/schemes",path: "secondary"},
       { label: "KCSE TRIAL EXAMINATIONS  ", value: "/kcse/trial/examinations",path: "secondary"},
       { label: "SECONDARY REVISION NOTES  ", value: "/secondary/notes" ,path: "secondary"},//the value is the routing path
       { label: "KNEC KCSE Past Papers  EXAMINATIONS ", value: "/kcse/past/papers",path: "secondary"},
       { label: "SECONDARY HOLIDAY ASSIGNMENTS  ", value: "/secondary/holiday/revision",path: "secondary"},
      
]
export const teachersCollageItems = [
       { label: "Diploma in Primary Teacher Education (DPTE) Notes  ", value: "/dpte/notes" ,path: "collage"},
       { label: "CPA Notes  ",  value: "/cpa/notes",path: "collage"},       
       { label: "ECD NOTES   ", value: "/ecd/notes" ,path: "collage"},//the value is the routing path
       { label: "DIPLOMA NOTES  ", value: "/diploma/notes",path: "collage"}
       
      
]
